import React from "react";
import { pageTitle } from "../../../constants/config";

const ContentLeft = () => <div className="wk-banner-left-content">
  <div className="wk-banner-product-name">
    {pageTitle}
  </div>
</div>;
export default ContentLeft;
